export default function updateStyling(document, elementKey, newValue) {
        if (!elementKey) {
            return null;
        }

        if (!newValue) {
            return null;
        }

        document.getElementById('timothyPwaIFrame').contentWindow.window.postMessage({"messageType":"updateStyling","messageData":{"invocableType": elementKey,"arguments":[{"key":elementKey,"value":newValue}]}}, "*")
    }